/**
 * client/src/pages/dashboard/components/sub-tab-params.ts
 *
 * Query-param names for the dashboard tabs' OWN sub-tabs.
 *
 * Each dashboard tab is mounted inside a shell whose route varies
 * (`/dashboard/:tab` normally, `/admin/platform/org/:orgId/:tab` in the
 * operator drill-in), so sub-tabs deep-link through a distinct query param
 * rather than the generic `?tab=` other pages use — see the long rationale in
 * `org-members.tsx`.
 *
 * They live here, not next to either the tab that READS them or the Overview
 * that WRITES them, because a deep link is a contract between two files: a
 * literal spelled at both ends is exactly how a link rots into "lands on the
 * page but the wrong section" with nothing failing.
 */

/** Members sub-tabs: `members` | `invitations` | `history`. */
export const MEMBERS_TAB_PARAM = "membersTab";

/** LEGACY, read-only. The Governance tab is gone (spec 2026-08-21-org-dashboard);
 *  this constant exists solely so `resolveDashboardTabRedirect` can interpret
 *  inbound links minted before the redesign. Never write it into a new href. */
export const GOVERNANCE_TAB_PARAM = "governanceTab";

/** Settings cards: scrolls to one card by id (module 05 — cards are always
 *  open, so there is nothing left to "expand"). */
export const SETTINGS_TAB_PARAM = "settingsTab";

/** Focus one row on the destination surface (DESIGN-SYSTEM §8 rule 3). */
export const FOCUS_PARAM = "focus";
